export default "/assets/images/column-image7.png?9556f83a4c7304c62a5551805cd4795c";